import { render, staticRenderFns } from "./Acoes.vue?vue&type=template&id=c264dd3a&"
import script from "./Acoes.vue?vue&type=script&lang=js&"
export * from "./Acoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports